module.exports = __webpack_public_path__ + "img/gc1.5ff2b22f.jpg";